<template>
<div class="section">
    <div class="container content-area">
        <ContentRow :is_mobile="is_mobile" v-for="row, i in site_data.rows" :key="i" :row="row" />
    </div>
</div>
</template>

<script>
import ContentRow from '../blocks/ContentRow';
export default {
    name        :   'HomePage',
    props       :   ['site_data', 'is_mobile'],
    components  :   { ContentRow }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue